import axios from "axios";

const API_BASE =
  import.meta.env.VITE_API_URL ?? "https://admin.smartica.co.in/api";

/*
 * Home hero banners.
 *
 * Payload shape (Strapi v4):
 *   { data: [ { id, attributes: { url, publishedAt, createdAt, updatedAt } } ] }
 *
 * `url` is already an absolute S3 URL, so it needs no host prefix.
 *
 * Ordering: the collection has no explicit order field, so slides follow `id`
 * (upload order). Re-uploading a banner moves it to the end of the rotation.
 */
export const HOME_BANNER_URL = `${API_BASE}/home-banners?sort=id:asc`;

/** Hero slides, in upload order. Rows without a usable url are dropped. */
export const fetchHomeBanners = async () => {
  const { data } = await axios.get(HOME_BANNER_URL);
  const rows = Array.isArray(data?.data) ? data.data : [];

  return rows
    .map((row) => ({ id: row?.id, url: row?.attributes?.url }))
    .filter((banner) => typeof banner.url === "string" && banner.url.length > 0);
};
